// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"287":"7601ae6a","791":"f406f7ee","859":"5e6e1853","977":"4b183b25"}[chunkId] + ".css";
};